import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AlertMessageStyles from './AlertMessage.styles';
import { AlertTextProps } from './types';

const AlertText = ({ config, promoterName }: AlertTextProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h5" className={AlertMessageStyles.titleText}>
        {t(config.titleKey)}
      </Typography>
      <Typography variant="body2" className={AlertMessageStyles.subtitleText}>
        {t(config.subtitleKey, { promoter: promoterName })}
      </Typography>
    </>
  );
};

export default AlertText;
